import { getErrorMessage } from './getErrorMessage';

export const getError = (e: unknown): Error =>
  e instanceof Error ? e : new Error(getErrorMessage(e));
